import { SecureAxios } from './Axios';
import { API_ROOT } from './Constants';
const CacheKey = 'waypoints';
const BASE_PATH = `${API_ROOT}/waypoints`;
const PATHS = {
    CREATE: BASE_PATH,
    DELETE: (waypontId) => `${BASE_PATH}/${waypontId}`,
    GET: (waypontId) => `${BASE_PATH}/${waypontId}`,
    LIST: BASE_PATH,
    UPDATE: (waypontId) => `${BASE_PATH}/${waypontId}`,
};
async function create(csrfToken, props) {
    return (await (await SecureAxios()).post(PATHS.CREATE, { ...props }, { headers: { 'X-CSRF-Token': csrfToken } })).data;
}
async function delete_(csrfToken, waypontId) {
    return (await (await SecureAxios()).delete(PATHS.DELETE(waypontId), { headers: { 'X-CSRF-Token': csrfToken } })).data;
}
async function get(waypontId, props) {
    const params = new URLSearchParams();
    if (props?.preload)
        params.append('preload', props.preload.join(','));
    return (await (await SecureAxios()).get(`${PATHS.GET(waypontId)}?${params.toString()}`)).data;
}
function getKey(waypontId, props) {
    return [CacheKey, 'get', waypontId, props];
}
async function list(flightPathId, props) {
    const params = new URLSearchParams();
    params.append('flightPathId', flightPathId);
    if (props.limit)
        params.append('limit', props.limit.toString());
    if (props.offset)
        params.append('offset', props.offset.toString());
    if (props.orderBy)
        params.append('orderBy', props.orderBy);
    if (props.order)
        params.append('order', props.order);
    if (props.query)
        params.append('q', props.query);
    return (await (await SecureAxios()).get(`${PATHS.LIST}?${params.toString()}`)).data;
}
function listKey(flightPathId, props) {
    return [CacheKey, 'list', flightPathId, props];
}
async function update(csrfToken, waypontId, props) {
    return (await (await SecureAxios()).put(PATHS.UPDATE(waypontId), { ...props }, { headers: { 'X-CSRF-Token': csrfToken } }))
        .data;
}
export default { CacheKey, create, delete_, get, getKey, list, listKey, update };
